import { apiClient } from '../../../helpers/apiHelperV2';
import { FETCH_WHEEL_DETAIL_FAILURE, FETCH_WHEEL_DETAIL_REQUEST, FETCH_WHEEL_DETAIL_SUCCESS } from '../../actionTypes';
import { standortUrlSelector } from '../../selectors/url';
import { wheelDetailResponseSelector } from '../../selectors/standort/wheelDetail';
import { shouldFetch } from '../../fetchStatus';

export const fetchWheelDetailIfNeeded = ({ wheelId }) => {
    return async function (dispatch, getState) {
        const state = getState();

        const standortUrl = standortUrlSelector(state);
        const wheelDetailResponse = wheelDetailResponseSelector(state, { wheelId });

        if (shouldFetch(wheelDetailResponse.status)) {
            dispatch({
                type: FETCH_WHEEL_DETAIL_REQUEST,
                payload: { standortUrl, wheelId },
            });
            try {
                const res = await apiClient.get(`/api/v1/standorte/${standortUrl}/tires/${wheelId}`);

                if (res.data && res.data.hersteller && res.data.hersteller === 'TECAR') {
                    try {
                        const constRes = await apiClient.get('/api/v1/GetConstant/TECAR-Datenfeed', {
                            params: { standortUrl: standortUrl },
                        });
                        if (constRes.data) {
                            if (res.data.saison === 'Sommer') {
                                res.data.description = constRes.data.content.descriptionSummer || '';
                            } else {
                                res.data.description = constRes.data.content.descriptionWinter || '';
                            }
                        }
                        dispatch({
                            type: FETCH_WHEEL_DETAIL_SUCCESS,
                            payload: { standortUrl, wheelId, data: res.data },
                        });
                    } catch (error) {
                        dispatch({
                            type: FETCH_WHEEL_DETAIL_FAILURE,
                            payload: { standortUrl, wheelId, error },
                        });
                    }
                } else {
                    dispatch({
                        type: FETCH_WHEEL_DETAIL_SUCCESS,
                        payload: { standortUrl, wheelId, data: res.data },
                    });
                }
            } catch (error) {
                dispatch({
                    type: FETCH_WHEEL_DETAIL_FAILURE,
                    payload: { standortUrl, wheelId, error },
                });
            }
        }
    };
};
